var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowSliderNext = function SvgArrowSliderNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124 4.5 119.89 0l-.866.949L121.81 4H0v1h121.81l-2.786 3.051.866.949L124 4.5Z",
    fill: "#8B8B95"
  })));
};

export default SvgArrowSliderNext;